import type { ReactNode } from 'react';
import { PureComponent } from 'react';

import { appEnv } from './environment';

export default class ErrorBoundary extends PureComponent<{ children: ReactNode }, { hasError: boolean }> {
  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service

    appEnv !== 'prod' && console.warn(error, info);
  }

  render() {
    const { children } = this.props;
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return appEnv === 'prod' ? null : <h1>Something went wrong.</h1>;
    }

    return children;
  }
}
